/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
import NavbarNotAuth from './components/navbarNotAuth'
import { useEffect, useState, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import DivBottom from './components/divBottom'
import axios from 'axios'
import CercaArtista from './components/cercaArtista'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import ArtistaDetails from './components/artistaDetails'

function Artisti() {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const bannerCorrente = searchParams.get('banner')
    const [artisti, setArtisti] = useState([])
    const [dati, setDati] = useState({})
    const idUser = localStorage.getItem('id')

    const descrizione = useRef()
    const body = useRef()
    const brnInsArtista = useRef()

    async function getArtisti() {
        try {
            const res = await axios.post(`/getArtisti/DESC/id`)
            const rty = res.data.filter(item => item.sezione === 'artista')
            setArtisti(rty)
        } catch (err) { console.log(err) }
    }
    async function dettagli(e) {
        setDati(e)
        setSearchParams({ banner: 'artistaDetails' })
        try {
            await axios.post(`/incView/${e.id}/${idUser}`).then(res => {
            })
        } catch (err) { console.log(err) }
    }
    useEffect(() => {
        if (descrizione.current) descrizione.current.innerHTML = dati.descrizione
    }, [dati])
    useEffect(() => {//cosa fare quando clicco previous page
        console.log('bannerCorrente:', bannerCorrente)
        if (bannerCorrente) {
            document.body.style.overflow = 'hidden'
        } else {//quando i banner sono chiusi
            document.body.style.overflow = ''
        }
    }, [bannerCorrente])
    useEffect(() => {
        getArtisti(); window.scrollTo(0, 500)
        const isRefresh = window.performance //intercetto il ricaricamneto della pagina (F5)
            ?.getEntriesByType('navigation')
            ?.[0].type === 'reload'
        if (isRefresh && searchParams.has('banner')) {//rimuovo 'banner' quando ricarico la pagina
            searchParams.delete('banner')
            setSearchParams(searchParams, { replace: true })
        }
        function lampeggiaSfondo() {
            if (brnInsArtista.current.style.backgroundColor === 'mediumblue') {
                brnInsArtista.current.style.color = 'black'
                brnInsArtista.current.style.backgroundColor = 'gold'
            }
            else {
                brnInsArtista.current.style.backgroundColor = 'mediumblue'
                brnInsArtista.current.style.color = 'whitesmoke'
            }
        }
        const intervallo = setInterval(lampeggiaSfondo, 1000)
        return () => clearInterval(intervallo)
    }, [])
    // useEffect(() => { console.log('dati:', dati) }, [dati])
    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        <p style={{ margin: '5rem 0 0 2rem' }}>\<b>Artisti</b></p>
        <CercaArtista caFornitore
            flag={bannerCorrente}
            dettagliIsOpen={(e) => { setSearchParams({ banner: e }) }}
            dati={(e) => { setDati(e) }}
        />
        <div style={{ textAlign: 'center' }}>
            <button ref={brnInsArtista} style={{ width: '80%', padding: '10px 5px', backgroundColor: 'red', fontWeight: '700', borderRadius: '10px', fontSize: 'large' }}
                onClick={() => { navigate('/addArtista') }}>INSERISCI UN ARTISTA</button>
        </div>

        <div className='mt-4 bodyPadding' ref={body}>
            {artisti &&
                artisti
                    .filter(item => (item.accettazione === 'true'))
                    .map(artista => (
                        <div key={artista.id} className='mt-5 bodyPadding' style={{ marginLeft: '.5em' }}>
                            {artista.img ?
                                <img src={`https://leuro-bucket.s3.amazonaws.com/${artista.img}`}
                                    style={{ maxWidth: '300px', maxHeight: '250px', borderRadius: '5px', objectFit: 'cover' }} />
                                :
                                <img src={require('./image/icons8-impostazioni-amministratore-maschio-32.png')} />
                            }
                            {artista.nome && artista.cognome &&
                                <div style={{ fontSize: 'medium', fontFamily: 'times', marginTop: '5px', opacity: '.7' }}>{artista.nome} {artista.cognome}</div>
                            }
                            {artista.gruppo &&
                                <p style={{
                                    backgroundImage: 'linear-gradient(to bottom, lightcyan, lightblue)', width: 'fit-content', padding: '3px 10px', borderRadius: '5px',
                                    fontWeight: '600', marginTop: '5px', border: '1px solid lightseagreen', fontSize: 'large'
                                }}>
                                    {artista.gruppo}
                                </p>
                            }

                            <p style={{ color: 'navy', margin: '5px 0 0 0', fontWeight: '600' }}>{artista.genere.toUpperCase()}</p>

                            {artista.regione &&
                                <p style={{ margin: '0 0 0 0' }}>{artista.regione} ({artista.città})</p>
                            }
                            <div><i>Nmero componenti: {artista.numero}</i></div>

                            {artista.telefono &&
                                <div className='mt-2'><img src={require('./image/icons8-telefono-cellulare-48.png')} width='25rem' style={{ marginRight: '1rem' }} />
                                    {artista.telefono}
                                </div>
                            }
                            {artista.emailUser &&
                                <div className='mt-2'><img src={require('./image/icons8-nuovo-messaggio-48.png')} width='25rem' style={{ marginRight: '1rem' }} />
                                    {artista.emailUser}
                                </div>
                            }

                            {artista.url &&
                                <div className='mt-1'>
                                    <a href={artista.url} style={{ textDecoration: 'none', color: 'black' }} target='_blank'>
                                        <img src={require("./image/icons8-sito-web-30.png")} style={{ marginRight: '.5em', opacity: '.7' }} />
                                        <span> Sito web </span>

                                    </a>
                                </div>
                            }

                            <div style={{ marginTop: '1rem', marginBottom: '4rem' }}>
                                <button className='btn btn-primary float-start' onClick={() => { dettagli(artista) }}
                                    style={{ fontSize: 'small', fontWeight: '600' }}>
                                    Dettagli
                                </button>
                            </div>
                            <hr style={{ height: '2px', backgroundColor: 'black' }} />
                        </div >
                    )
                    )
            }
        </div>
        {dati.id && <ArtistaDetails flag2={bannerCorrente} artista={dati} />}
        <DivBottom />
    </>)
}
export default Artisti